import { Button } from "antd";
import { EditableRow, EditableCell } from '@/components/YHEditTable/editTable'
import { YhBox } from "@/components/YhBox";
import { fieldSetModel } from "../fieldSetModel";
import { PlusOutlined } from '@ant-design/icons'
import { Checkbox, message, Modal, Table } from 'antd'
import { IFieldSetupColumnDetail } from "../FieldSetTypes"

export const Right = () => {

    const {
        fieldList, setFieldList,
        handleInsertField, handleUpdateField,
        handleDeleteField, handleInsertBatchFields,
        selectedRowKeys, setSelectedRowKeys,
        selectedData, setSelectedData,
    } = fieldSetModel();

    const handleDelete = (r: any) => {
        let usedColumn: string[] = []
        if (usedColumn.includes(r.id)) {
            return message.error(`字段--${r.name}在数据统计中使用，不能删除！`)
        }
        Modal.confirm({
            title: '删除',
            centered: true,
            closable: true,
            content: <div>确定要删除字段--{r.name}</div>,
            onOk() {
                handleDeleteField(r.id)
            },
        })
    }

    const handleInsert = () => {
        Modal.confirm({
            title: '添加',
            centered: true,
            closable: true,
            content: <div>确定要添加一行字段？</div>,
            onOk() {
                handleInsertField()
            },
        })
    }

    const handleInsertBatch = () => {
        if (selectedRowKeys.length === 0) {
            message.warning("请选择需要保存到全部加盟商的数据！")
            return;
        }
        Modal.confirm({
            title: '保存到全部加盟商',
            centered: true,
            closable: true,
            content: <div>确定保存到全部加盟商？</div>,
            onOk() {
                handleInsertBatchFields()
            },
        })
    }

    const columns = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            align: 'center',
            render: (t, r, i) => i + 1,
        },
        {
            title: '操作',
            width: 60,
            fixed: 'left',
            align: 'center',
            render(r) {
                return (
                    <span
                        style={{
                            fontSize: '14px',
                            color: '#4165E3',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            handleDelete(r)
                        }}
                    >
                        删除
                    </span>
                )
            },
        },
        {
            title: '字段名称',
            width: 150,
            dataIndex: 'name',
            align: 'center',
            editable: true,
        },
        {
            title: '是否原有',
            width: 80,
            dataIndex: 'isCommon',
            align: 'center',
            render(t, r) {
                return (
                    <Checkbox
                        key={'isCommon' + r.id || r.temporaryId}
                        checked={r.isCommon == "0" ? false : true}
                        onChange={(e) => {
                            handleSave({ ...r, isCommon: e.target.checked ? "1" : "0" })
                        }}
                    />
                )
            },
        },
        {
            title: '是否必填',
            width: 80,
            dataIndex: 'isNull',
            align: 'center',
            render(t, r) {
                return (
                    <Checkbox
                        key={'isNull' + r.id || r.temporaryId}
                        checked={r.isNull == "0" ? false : true}
                        onChange={(e) => {
                            handleSave({ ...r, isNull: e.target.checked ? "1" : "0" })
                        }}
                    />
                )
            },
        },
        {
            title: '是否参与计算',
            width: 100,
            dataIndex: 'isCount',
            align: 'center',
            render(t, r) {
                return (
                    <Checkbox
                        key={'isCount' + r.id || r.temporaryId}
                        checked={r.isCount == "0" ? false : true}
                        onChange={(e) => {
                            handleSave({ ...r, isCount: e.target.checked ? "1" : "0" })
                        }}
                    />
                )
            },
        },
        {
            title: '字段值',
            width: 100,
            dataIndex: 'fieldValue',
            align: 'center',
            editable: true,
        },
        {
            title: '计算公式',
            width: 150,
            dataIndex: 'calculationFormula',
            align: 'center',
            editable: true,
        },
        {
            title: '标识',
            width: 150,
            dataIndex: 'identification',
            align: 'center',
            editable: true,
        },
        {
            title: '位置',
            width: 140,
            dataIndex: 'arrange',
            align: 'center',
            editable: true,
            editType: "select",
            options: [
                { value: 'arrange-item.details', label: '工单项目明细' },
                { value: 'arrange-material.details', label: '工单用料明细' },
                { value: 'arrange-list', label: '工单列表' },
                { value: 'arrange-list-total', label: '统计' },
            ],
            render: (text: string) => {
                return text === 'arrange-item.details' ? '工单项目明细' :
                    text === 'arrange-material.details' ? '工单用料明细' :
                        text === 'arrange-list' ? '工单列表' :
                            text === 'arrange-list-total' ? '统计' : ''
            },
        },
    ]

    const newColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => {
                let editable = col?.editable
                if (col.dataIndex === 'itemCode') {
                    editable = !record.isChoosed
                }
                if (col.dataIndex === 'itemNum' || col.dataIndex === 'itemPrice') {
                    editable = !!record.isChoosed
                }
                return {
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    mode: col.mode,
                    handleSave: handleSave,
                    onInputEnter: col.onInputEnter,
                }
            },
        }
    })

    //内联编辑
    const handleSave = (row: any) => {
        const newData = [...fieldList]
        const index = newData.findIndex((item) => row.id === item.id)
        const item = newData[index]
        newData.splice(index, 1, {
            ...item,
            ...row,
        })
        setFieldList(newData)
        handleUpdateField(row)
    }

    const onRow = (record: IFieldSetupColumnDetail, selected: boolean) => {
        let arr: string[] = [];
        let list: IFieldSetupColumnDetail[] = [];
        if (selected) {
            arr = Array.from(new Set([...selectedRowKeys, record.id]));
            list = Array.from(new Set([...selectedData, record]));
        } else {
            arr = selectedRowKeys.filter(item => { return item !== record.id });
            list = selectedData.filter(item => item.id !== record.id)
        }
        setSelectedRowKeys(arr);
        setSelectedData(list);
    };

    const onSelectAll = (selected: boolean, changeRows: IFieldSetupColumnDetail[]) => {
        if (selected) {
            let addSelected: string[] = [];
            let addRows: IFieldSetupColumnDetail[] = [];
            for (const item of changeRows) {
                addSelected.push(item.id);
                addRows.push(item);
            }
            setSelectedRowKeys([...addSelected, ...selectedRowKeys]);
            setSelectedData([...addRows, ...selectedData]);
        } else {
            setSelectedRowKeys(selectedRowKeys.filter((id) => {
                return !changeRows.some((item) => item.id === id)
            }));
            setSelectedData(selectedData.filter((data) => {
                return !changeRows.some((item) => item.id === data.id)
            }));
        }
    }

    const rightChildren = (<Button type="link" shape="round" onClick={handleInsertBatch}>保存到全部加盟商</Button>);

    return (
        <>
            <YhBox rightChildren={rightChildren} style={{ height: '100vh', marginRight: "5%" }} title="字段配置">
                <Table
                    rowKey={(record) => record.id}
                    columns={newColumns}
                    dataSource={fieldList}
                    rowSelection={{
                        selectedRowKeys: selectedRowKeys,
                        onSelectAll: (selected, selectedRows, changeRows) => onSelectAll(selected, changeRows),
                        onSelect: (record, selected, selectedRows) => onRow(record, selected),
                    }}
                    components={{
                        body: {
                            row: EditableRow,
                            cell: EditableCell,
                        },
                    }}
                    scroll={{ x: '1000px', y: '650px' }}
                    bordered
                    footer={() => (
                        <div
                            style={{ color: '#2956FE', cursor: 'pointer' }}
                            onClick={() => {
                                handleInsert()
                            }}
                        >
                            <PlusOutlined />
                            新增一行
                        </div>
                    )}
                    pagination={false}
                />
            </YhBox >
        </>
    )
}
